import {Notifications} from 'client';
import {useMemo} from 'react';

export const useVisibleNotifications = (data: Notifications | undefined) => {
  return useMemo(
    () => ({
      actionItems: data?.action_items ?? [],
      notifications: data?.notifications ?? [],
    }),
    [data]
  );
};
